export const CLIENT_QUESTIONNAIRE_QUESTIONS = [
    {
        id: 'position',
        index: 1,
        title: 'Кто вы по отношению к этому товару?',
        options: [
            'Производитель',
            'Официальный дистрибьютор',
            'Перепродавец (опт + розница)',
            'Реселлер (переупаковка чужого товара)',
        ],
    },
    {
        id: 'horizon',
        index: 2,
        title: 'На какой срок вы планируете продавать ваш товар?',
        options: [
            'До полугода, распродажа остатков',
            'От полугода до года',
            'От года до двух лет',
            'Больше двух лет, долгий флагман',
        ],
    },
    {
        id: 'price',
        index: 3,
        title: 'Какой ценовой уровень у вашего товарного портфеля?',
        options: [
            'Низкий, бюджетный сегмент',
            'Средний, массовый сегмент',
            'Высокий, премиальный сегмент',
            'Разный, несколько ценовых линеек',
        ],
    },
    {
        id: 'priority',
        index: 4,
        title: 'Что для вас сейчас важнее всего?',
        options: [
            'Рост рейтинга и отзывов',
            'Баланс рейтинга и прибыли',
            'Максимальная прибыль',
            'Выход на новые площадки',
        ],
    },
    {
        id: 'control',
        index: 5,
        title: 'Насколько вы можете менять качество товара?',
        options: [
            'Полностью контролирую производство',
            'Могу просить завод доработать',
            'Почти не влияю на качество',
            'Совсем не влияю на качество',
        ],
    },
    {
        id: 'channels',
        index: 6,
        title: 'Есть ли у вас прямой контакт с покупателем?',
        options: [
            'Да, личные сообщения на площадке',
            'Только ответы в отзывах',
            'Только через поддержку площадки',
            'Нет никакого прямого контакта',
        ],
    },
    {
        id: 'returns',
        index: 7,
        title: 'Можете ли вы оформить возврат или замену?',
        options: [
            'Да, и возврат, и замену',
            'Да, только замену товара',
            'Да, только возврат денег',
            'Нет, этим занимается площадка',
        ],
    },
    {
        id: 'sla',
        index: 8,
        title: 'Как быстро вы обычно отвечаете на отзывы?',
        options: ['В течение двух часов', 'В течение одного дня', 'В течение трёх дней', 'Редко, позже трёх дней'],
    },
    {
        id: 'acknowledgment',
        index: 9,
        title: 'Как вы пишете о причине брака в отзыве?',
        options: [
            'Всегда пишу, что виноват товар, не клиент',
            'Чаще пишу, что виноват товар, редко клиент',
            'Иногда пишу, что клиент сам виноват',
            'Часто объясняю, что клиент сам виноват',
        ],
    },
    {
        id: 'advice',
        index: 10,
        title: 'Готовы ли вы давать советы по использованию товара?',
        options: [
            'Да, всегда и подробно',
            'Да, только когда есть ошибка клиента',
            'Да, через заранее подготовленные гайды',
            'Нет, это не моя зона ответственности',
        ],
    },
    {
        id: 'responsibility',
        index: 11,
        title: 'Кто, по-вашему, должен решать проблему клиента?',
        options: [
            'В первую очередь мы',
            'В поддержку площадки направляем',
            'Пусть клиент сам решает',
            'Площадка решает без нас',
        ],
    },
    {
        id: 'attitude',
        index: 12,
        title: 'Как вы относитесь к негативным отзывам и критике?',
        options: [
            'Как к возможности стать лучше',
            'Как к полезной информации',
            'Как к обычной части работы',
            'Как к угрозе рейтингу',
        ],
    },
    {
        id: 'emotions',
        index: 13,
        title: 'Можно ли писать "к сожалению", "нам жаль" в ответах?',
        options: [
            'Нет, такие фразы никогда не использовать',
            'Редко, только при тяжёлом браке',
            'Можно иногда, для выражения сочувствия',
            'Можно часто, почти в каждом ответе',
        ],
    },
    {
        id: 'tone',
        index: 14,
        title: 'Какой стиль ответов вы предпочитаете?',
        options: [
            'Официальный, как письмо от компании',
            'Дружелюбный, как живой диалог',
            'Деловой, кратко и по фактам',
            'Объяснительный, с разбором причин',
        ],
    },
    {
        id: 'personalization',
        index: 15,
        title: 'Нужно ли обращаться к покупателю по имени?',
        options: [
            'Да, всегда по имени',
            'Иногда, когда имя указано',
            'Редко, только в особых случаях',
            'Никогда не использую имя',
        ],
    },
    {
        id: 'gratitude',
        index: 16,
        title: 'Насколько важно писать "спасибо за отзыв"?',
        options: [
            'Важно в начале каждого ответа',
            'Важно в конце каждого ответа',
            'Достаточно один раз в тексте',
            'Не считаю это нужным',
        ],
    },
    {
        id: 'logic',
        index: 17,
        title: 'Можно ли ограничиваться общими фразами без конкретики?',
        options: [
            'Нет, нужны только конкретные действия и факты',
            'Иногда, но обязательно с конкретикой рядом',
            'Иногда можно только общую формулировку',
            'Часто достаточно общих формулировок',
        ],
    },
    {
        id: 'solution',
        index: 18,
        title: 'Насколько обязательно предлагать решение в ответе?',
        options: [
            'Всегда предлагать замену или помощь',
            'Только если отзыв негативный',
            'Только если клиент просит решение',
            'Обычно не предлагаю решений',
        ],
    },
    {
        id: 'balance',
        index: 19,
        title: 'Как вы сочетаете признание и объяснения в сложных отзывах?',
        options: [
            'Признаю проблему и подробно объясняю',
            'Признаю, но почти не объясняю',
            'Не признаю, только объясняю позицию',
            'Ни не признаю, ни не объясняю',
        ],
    },
    {
        id: 'answer_length',
        index: 20,
        title: 'Какой объём ответа вам комфортен?',
        options: [
            'Короткий, до 3-х предложений',
            'Средний, 4-7 предложений',
            'Подробный, больше 7 предложений',
            'Очень короткий, одно предложение',
        ],
    },
    {
        id: 'accuracy',
        index: 21,
        title: 'Нужно ли перед ответом изучать хар-ки товара на сайте?',
        options: [
            'Да, всегда подробно смотреть сайт и карточку',
            'Да, только при сложных или спорных отзывах',
            'Иногда, по ситуации, без жёсткого правила',
            'Нет, достаточно текста отзыва',
        ],
    },
    {
        id: 'no_links',
        index: 22,
        title: 'Можно ли оставлять ссылки в публичном ответе?',
        options: [
            'Никогда никаких ссылок',
            'Только на сайт производителя',
            'Можно на полезные материалы',
            'Можно любые ссылки',
        ],
    },
    {
        id: 'no_discounts',
        index: 23,
        title: 'Можно ли упоминать скидки и бонусы в ответах?',
        options: [
            'Никогда не упоминать',
            'Только для особо недовольных',
            'Иногда, по своему усмотрению',
            'Часто, как часть стратегии продаж',
        ],
    },
    {
        id: 'no_markdown',
        index: 24,
        title: 'Как вы относитесь к выделениям текста и разметке?',
        options: [
            'Только простой текст без выделений',
            'Допускаю редкие выделения',
            'Можно активно выделять части текста',
            'Люблю сложную разметку',
        ],
    },
    {
        id: 'plain_text',
        index: 25,
        title: 'Насколько важна аккуратность форматирования текста?',
        options: [
            'Очень важна, всё должно быть ровно',
            'Желательна, но не критично',
            'Не обращаю особого внимания',
            'Вообще не важно',
        ],
    },
    {
        id: 'no_contacts',
        index: 26,
        title: 'Можно ли публиковать телефон или почту в ответах?',
        options: [
            'Никогда публично не указывать',
            'Только в личных сообщениях',
            'Иногда, если это просит клиент',
            'Можно указывать в каждом ответе',
        ],
    },
    {
        id: 'taxonomy',
        index: 27,
        title: 'Как вы сейчас анализируете отзывы в целом?',
        options: [
            'Регулярно считаю и ищу повторяющиеся темы',
            'Замечаю повторы, но без подсчётов',
            'Смотрю только отдельные яркие случаи',
            'Почти не анализирую отзывы',
        ],
    },
    {
        id: 'roi_improvements',
        index: 28,
        title: 'Готовы ли вы менять товар или сервис по отзывам?',
        options: [
            'Да, регулярно вносим улучшения',
            'Да, если очевидна выгода',
            'Иногда, если есть свободные ресурсы',
            'Нет, почти ничего не меняем',
        ],
    },
] as const;

export type ClientQuestionnaireAnswerId = (typeof CLIENT_QUESTIONNAIRE_QUESTIONS)[number]['id'];
export type ClientQuestionnaireQuestionDefinition = (typeof CLIENT_QUESTIONNAIRE_QUESTIONS)[number];
export type ClientQuestionnaireVisibleQuestionDefinition = Omit<ClientQuestionnaireQuestionDefinition, 'index'> & {
    index: number;
};

export const CLIENT_QUESTIONNAIRE_ANSWER_KEYS = CLIENT_QUESTIONNAIRE_QUESTIONS.map((question) => question.id) as [
    ClientQuestionnaireAnswerId,
    ...ClientQuestionnaireAnswerId[],
];

export const CLIENT_QUESTIONNAIRE_HIDDEN_DEFAULT_ANSWERS = {
    sla: 'В течение двух часов',
    answer_length: 'Средний, 4-7 предложений',
    accuracy: 'Да, только при сложных или спорных отзывах',
    no_links: 'Никогда никаких ссылок',
    no_discounts: 'Никогда не упоминать',
    no_markdown: 'Только простой текст без выделений',
    plain_text: 'Очень важна, всё должно быть ровно',
    no_contacts: 'Никогда публично не указывать',
    taxonomy: 'Регулярно считаю и ищу повторяющиеся темы',
    roi_improvements: 'Да, регулярно вносим улучшения',
} as const satisfies Partial<Record<ClientQuestionnaireAnswerId, string>>;

const CLIENT_QUESTIONNAIRE_HIDDEN_ANSWER_IDS = Object.keys(
    CLIENT_QUESTIONNAIRE_HIDDEN_DEFAULT_ANSWERS,
) as ClientQuestionnaireAnswerId[];

const CLIENT_QUESTIONNAIRE_HIDDEN_ANSWER_ID_SET = new Set<ClientQuestionnaireAnswerId>(
    CLIENT_QUESTIONNAIRE_HIDDEN_ANSWER_IDS,
);

export const isClientQuestionnaireAnswerHidden = (answerId: ClientQuestionnaireAnswerId): boolean =>
    CLIENT_QUESTIONNAIRE_HIDDEN_ANSWER_ID_SET.has(answerId);

export const CLIENT_QUESTIONNAIRE_VISIBLE_QUESTIONS: ClientQuestionnaireVisibleQuestionDefinition[] =
    CLIENT_QUESTIONNAIRE_QUESTIONS.filter((question) => !isClientQuestionnaireAnswerHidden(question.id)).map(
        (question, index) => ({
            ...question,
            index: index + 1,
        }),
    );

export const applyClientQuestionnaireHiddenDefaultAnswers = (
    answers: Record<ClientQuestionnaireAnswerId, string>,
): Record<ClientQuestionnaireAnswerId, string> => ({
    ...answers,
    ...CLIENT_QUESTIONNAIRE_HIDDEN_DEFAULT_ANSWERS,
});

export const removeClientQuestionnaireHiddenDefaultAnswers = (
    answers: Record<ClientQuestionnaireAnswerId, string>,
): Record<ClientQuestionnaireAnswerId, string> => ({
    ...answers,
    ...Object.fromEntries(CLIENT_QUESTIONNAIRE_HIDDEN_ANSWER_IDS.map((answerId) => [answerId, ''])),
});

export const buildEmptyClientQuestionnaireAnswers = (): Record<ClientQuestionnaireAnswerId, string> =>
    applyClientQuestionnaireHiddenDefaultAnswers(
        Object.fromEntries(CLIENT_QUESTIONNAIRE_ANSWER_KEYS.map((answerKey) => [answerKey, ''])) as Record<
            ClientQuestionnaireAnswerId,
            string
        >,
    );

export const countClientQuestionnaireVisibleAnswers = (
    answers: Partial<Record<ClientQuestionnaireAnswerId, unknown>>,
): number =>
    CLIENT_QUESTIONNAIRE_VISIBLE_QUESTIONS.filter((question) => {
        const value = answers[question.id];
        return typeof value === 'string' && value.trim() !== '';
    }).length;

const QUESTION_OPTIONS_BY_ID = new Map(
    CLIENT_QUESTIONNAIRE_QUESTIONS.map((question) => [question.id, new Set<string>(question.options)]),
);

export const isValidClientQuestionnaireAnswer = (
    questionId: ClientQuestionnaireAnswerId,
    value: unknown,
): value is string => {
    if (typeof value !== 'string') {
        return false;
    }

    return value === '' || QUESTION_OPTIONS_BY_ID.get(questionId)?.has(value) === true;
};

export const normalizeClientQuestionnaireAnswers = (
    answersValue: unknown,
): Record<ClientQuestionnaireAnswerId, string> => {
    const normalizedAnswers = buildEmptyClientQuestionnaireAnswers();

    if (!answersValue || typeof answersValue !== 'object' || Array.isArray(answersValue)) {
        return normalizedAnswers;
    }

    const sourceAnswers = answersValue as Record<string, unknown>;
    for (const answerKey of CLIENT_QUESTIONNAIRE_ANSWER_KEYS) {
        const rawValue = sourceAnswers[answerKey];
        if (isValidClientQuestionnaireAnswer(answerKey, rawValue)) {
            normalizedAnswers[answerKey] = rawValue;
        }
    }

    return applyClientQuestionnaireHiddenDefaultAnswers(normalizedAnswers);
};
